import type { ConfigType } from '@plone/registry';

import RedirectHomepageEdit from '../components/RedirectHomepageEdit/RedirectHomepageEdit';
import RedirectHomepageView from '../components/RedirectHomepageView/RedirectHomepageView';
import RedirectToInitialPage from '../components/RedirectToInitialPage/RedirectToInitialPage';
import QuadreMedicPage from '../components/views/QuadreMedicPage';
import { medicalServicesSectionAlternation, quadreMedicFolderAlternation } from '../helpers/localizedSectionPath';

export default function installRoutes(config: ConfigType) {
  const langs = (config.settings.supportedLanguages || ['ca']).join('|');
  const homepageId = config.settings.homepageContentId || 'pagina-inicial';

  config.addonRoutes = [
    {
      path: `/(${langs})/edit`,
      component: RedirectHomepageEdit,
      exact: true,
    },
    {
      path: `/(${langs})/${homepageId}`,
      component: RedirectHomepageView,
      exact: true,
    },
    {
      path: `/(${langs})/(${medicalServicesSectionAlternation})/(${quadreMedicFolderAlternation})/:metgeSlug`,
      component: QuadreMedicPage,
      exact: true,
    },
    {
      path: '/',
      exact: true,
      component: RedirectToInitialPage,
    },
    ...(config.addonRoutes || []),
  ];

  return config;
}
